<div *ngIf="reviews$ | async as reviews" class="d-flex justify-content-start align-items-end">
  <ng-container
    *ngIf="(reviews.meta.record_count !== 0 && reviews.meta.product.star_rating > 2) || reviews.meta.product.star_rating === 0"
  >
    <dcp-star-rating [starRating]="reviews.meta.product.star_rating" class="d-inline-block"></dcp-star-rating>
    <span class="align-baseline small-line-height ms-3 ds-cursor--pointer">
      <span (click)="scrollToReviewSection()"
            (keyup.enter)="scrollToReviewSection()"
            *ngIf="reviews.meta.record_count !== 0 && reviews.meta.product.star_rating > 2"
            class="focusable focusable__element underline--hover--black"
            id="hero-review-scroll-to-review-section"
            tabindex="0">
        {{'productReview.reviewCount' | cxTranslate: {count: reviews.meta.record_count} }}
      </span>
      <span *ngIf="reviews.meta.record_count === 0"
            id="hero-review-open-write-review-modal">
        <span class="ds-color--grey-3 me-1">
          {{'productReview.reviewCountEmpty' | cxTranslate: {count: reviews.meta.record_count} }}
        </span>
        <span (click)="reviewDialogService.openWriteAReviewDialog(reviews.meta.product)"
              (keyup.enter)="reviewDialogService.openWriteAReviewDialog(reviews.meta.product)"
              class="focusable focusable__element underline--hover--black" tabindex="0">
              {{'productReview.writeAReview' | cxTranslate}}
        </span>
      </span>
    </span>
  </ng-container>
</div>
